import React, { Component } from 'react';
import { Row, Col, Table, message, Spin } from 'antd';
import { useParams } from 'react-router-dom';

import { _pubchem } from './table_config';
import asyncFetch from '../../utils/asyncFetch';
import { asArray } from '../../utils/dataGuards';

const WithPathway = (props) => {
    let params = useParams();
    return <Pathway {...props} params={params} />
}

class Pathway extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gene: this.props.params.gene,
            record: [],
            loading: true
        }
    }

    componentDidMount() {
        const { gene } = this.state;
        asyncFetch('GET', '/basic_table/pubchem_data', {SYMBOL: gene, current_page: 1, page_size: 10000},
            (res) => {
                if (res.code === 200) {
                    const result = asArray(res.data).map((val, idx) => ({ ...(val || {}), key: idx }));
                    this.setState({
                        record: result,
                        loading: false
                    })
                } else {
                    message.error(res.msg)
                }
            },
        {}, 'cors', {}, false);
    }

    render() {
        return (
            <Spin spinning={this.state.loading}>
                <Row>
                    <Col span={24}>
                        <Table
                            scroll={{x: 1200}}
                            columns={_pubchem}
                            dataSource={this.state.record}
                        />
                    </Col>
                </Row>
            </Spin>
        )
    }
}

export default WithPathway
